import React, { FC, useEffect, useState } from 'react';

import {
  BluePrintsRead,
  ComplianceSummaryAccount,
} from '@ariksa/compliance-policies/api';
import { Box } from '@chakra-ui/react';
import { isEmpty, map } from 'lodash';

import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { PieChart } from 'components/Visualization';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { useCloudAccountId } from 'containers/Setup/CloudAccounts/utils';

interface Props {
  violationsByAccount: {
    data: ComplianceSummaryAccount[];
    isLoading?: boolean;
  };
  blueprints: { data: Record<string, BluePrintsRead>; isLoading?: boolean };
  label: string;
  outerRadius?: string;
  innerRadius?: string;
  cx?: string;
  legendsW?: string;
}

export const ViolationsByAccountsComponent: FC<Props> = props => {
  const {
    violationsByAccount,
    blueprints,
    label,
    outerRadius = '95%',
    innerRadius = '86%',
    cx = '45%',
    legendsW = '45%',
  } = props;
  const [data, setData] = useState<any>();
  const { toCloudAccountName } = useCloudAccountId();

  useEffect(() => {
    if (violationsByAccount.data) {
      setData(
        map(violationsByAccount.data, o => ({
          name: toCloudAccountName(o.account_id),
          value: o.failed,
        })),
      );
    }
  }, [violationsByAccount.data, toCloudAccountName]);

  return (
    <DashboardWidget
      label={label}
      content={
        <Box w="full" h="full">
          <PieChart
            isLoading={violationsByAccount.isLoading || blueprints.isLoading}
            data={data}
            dataKey="value"
            total={formatNumber(
              data?.reduce((s, el) => s + el?.value || 0, 0),
              1,
            )}
            activeShape={false}
            outerRadius={outerRadius}
            innerRadius={innerRadius}
            styles={{
              pie: { cx: isEmpty(data) ? '50%' : cx },
              legend: {
                wrapperStyle: {
                  width: legendsW,
                },
              },
            }}
          />
        </Box>
      }
      styles={{ contentWrapper: { px: 0, pt: 0, pb: 1 } }}
    />
  );
};
